<template>
	<div style="min-height: 500px;">
		<div style="margin-bottom: 20px;">
			<Button type="primary" slot="extra" @click="AddRecordClick">写日志</Button>
		</div>
		<div style="display: flex; width: 900px; justify-content: space-between; padding-bottom: 10px">
			<i-input placeholder='搜索员工姓名' v-model="name" style="width: 230px;">
			</i-input>
			<DatePicker :value="dateTime" @on-change="(e) => {dateTime = e}" type="date" placeholder="选择日期"
				style="width: 200px"></DatePicker>
			<Select v-model="type" style="width:200px" placeholder="选择日志类型">
				<Option v-for="item in type_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<Button @click="initSearch">重置</Button>
			<Button type="primary" @click="search">搜索</Button>
		</div>
		<div class="record_box">
			<div class="list_css" v-for="(item,index) in list" :key='index'>
				<Card style="margin-top: 20px;">
					<div >
						<div style="display: flex; width: 380px; justify-content: space-between;align-items: center;">
							<Avatar size="50" :src="item.avatar" />
							<div>
								<div style="display: flex;width: 100%; justify-content: space-between;">
									<span style="font-size: 23px;color:#63B3E6;cursor: pointer;" @click="lookLog(item.id)">{{item.name}}</span>
									<span style="font-size: 23px; color: #D0D2D4;" v-if="item.is_read == 1">已读</span>
									<span style="font-size: 23px; color: red" v-else>未读</span>
								</div>
								<div
									style="font-size: 16px; color: #A89A93; display: flex; width: 300px; justify-content: space-between;">
									<span style="">{{item.created_at}}</span>
									<span>{{item.department_name}}</span>
								</div>
							</div>
						</div>
						<div class="list_width" style="margin-top: 10px;font-weight: bold;" >今日工作总结：</div>
						<Input v-model="item.summarize" type="textarea" :rows="6" />
						<div class="list_width" style="margin-top: 10px;font-weight: bold;">需要协助或遇到的问题：</div>
						<div style="margin-top: 5px;margin-left: 108px;">{{item.issue}}</div>
						<div class="list_width" style="margin-top: 10px;font-weight: bold;">附件：</div>
						<div class="demo-upload-list" v-for="(img,index) in item.ext_info.imgList" :key="index">
							<template v-if="img.status === 'finished'">
								<img :src="img.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(img.url)"></Icon>
								</div>
							</template>
						</div>

					</div>
					<!--div class="list_width"
							style="width: 80%; margin-top: 10px;  border: 1px solid #DADCE0; border-radius: 5px; padding: 10px;">
							<div style="width: 100%;" v-for="(remark, remarkIndex) in item.ext_info.comment"><span
									style="font-weight: bold;">{{remark}}</span></div>
							<div style="display: flex;  justify-content: flex-end;width: 100%;">
								<Input v-model="remarkValue" style="width: 300px;margin-right: 20px;" />
								<Button type="primary" @click="saveComment" :data-id="item.id">点评/回复</Button>
							</div>
						</div-->
				</Card>
			</div>
			<div class="pager" style="margin-right: 10%">
				<Page :total="count" :page-size="10" :current="page" @on-change="changePage" size="small"
					show-elevator />
			</div>
		</div>
		<!-- 写日志弹出框 -->
		<Modal v-model="addRecordShow" width="1000">
			<div>
				<span style="font-size: 20px; font-weight: bold;"> 写日志</span>
				<DatePicker type="date" :value="logTime" placeholder="选择日志日期" @on-change="timePeriodDateChange"
					style="width: 200px;padding-left: 30px;"></DatePicker>
			</div>
			<div v-if="logTime != ''">
				<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate">
					<span>全选</span>
				</Checkbox>
				<CheckboxGroup v-model="cidType" @on-change="checkAllGroupChange">
					<Checkbox label="5" border>综合</Checkbox>
					<Checkbox label="1" border>公积金</Checkbox>
					<Checkbox label="7" border>社保</Checkbox>
					<Checkbox label="3" border>车抵</Checkbox>
					<Checkbox label="4" border>企业</Checkbox>
					<Checkbox label="2" border>房抵</Checkbox>
					<Checkbox label="6" border>朋友圈</Checkbox>
				</CheckboxGroup>
				<div>
					<Table :columns="columns" :data="datas" ref="table" :height="300">
					</Table>
				</div>
				<div class="list_width"
					style="display: flex; justify-content: space-between; width: 355px; margin-top: 5px;">
				</div>
				<div class="list_width" style="margin-top: 10px;font-weight: bold;">今日工作总结：</div>
				<Input v-model="staticData.summarize" type="textarea" :rows="6" />
				<div class="list_width" style="margin-top: 10px;font-weight: bold;">遇到的问题或明天需要协助的事项：</div>
				<Input v-model="staticData.issue" type="textarea" :rows="4" />
				<div class="list_width" style="margin-top: 10px;font-weight: bold;">附件</div>
			</div>
			<MyUpload ref="upload"></MyUpload>
			<div slot="footer">
				<Button type="primary" @click="save">确定</Button>
			</div>
		</Modal>
		<Modal title="阅览图片" v-model="visible" width="650px">
			<img :src="imgName" v-if="visible" style="width: 100%">
		</Modal>
	</div>
</template>

<script>
	import MyUpload from '../../tool/Upload.vue'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getAdvTypeGroupByCityStaticList,
		saveOperaterReport,
		getOperaterLogList,
		getLogDetail,
		getOldSystemId
	} from "../../../api/advManage";
	import {
		getReportList,
		saveReportComment
	} from '@/api/task'
	export default {
		name: "RecordList",
		computed: {
			...mapGetters(['userInfo', 'token']),
		},
		components: {
			MyUpload
		},
		created() {
			this.getList();
		},
		watch: {
			id() {
				this.getLogDetail();
			},
			cidType() {
				this.getAdvData();
			},
		},
		data() {
			return {
				addRecordShow: false,
				follow_uid: '',
				get_uid: '',
				timeType: '3',
				client_type: '4',
				remarkValue: '',
				name: '',
				dateTime: '',
				type: '',
				cidType: [],
				timePeriod: '7',
				tabs_value: 'day',
				visible: false,
				logTime: '',
				timePeriodDate: [],
				type_list: [{
					value: 'day',
					label: '日报'
				}, {
					value: 'week',
					label: '周报'
				}, {
					value: 'month',
					label: '月报'
				}, ],
				staticData: {

				},
				columns: [{
						"title": "账户类型",
						"key": "type",
						"align": "center",
					},
					{
						"title": "城市",
						"key": "city",
						"align": "center",
					},
					{
						"title": "消耗",
						"key": "cost",
						"align": "center",
					},
					{
						"title": "平均成本",
						"key": "average_cost",
						"align": "center",
					},
					{
						"title": "广告转化数",
						"key": "account_convert",
						"align": "center",
					},
					{
						"title": "系统转化数",
						"key": "srcNum",
						"align": "center",
					},
					{
						"title": "回传数量",
						"key": "backNum",
						"align": "center",
					},
					{
						"title": "三星+",
						"key": "threePlus",
						"align": "center",
					},
					{
						"title": "优质率",
						"key": "threePlusRate",
						"align": "center",
					},
					{
						"title": "优质成本",
						"key": "threePlusCost",
						"align": "center",
					},
				],
				list: [],
				indeterminate: true,
				checkAll: false,
				datas: [],
				count: 0,
				page: 1,
			}
		},
		methods: {
			...mapActions([
				'getUserInfo',
			]),
			async loadData() {
				let that = this;
			},
			async getList() {
				let that = this;
				that.list = [];
				let data = {
					token: that.token,
					type: that.type,
					dateTime: that.dateTime,
					name: that.name,
					page: that.page,
					limit: 10
				}
				let res = await getOperaterLogList(that, data);
				if (res.code == 1) {
					that.count = res.count;
					that.list = res.data.list;
					console.log(that.list)
					that.getUserInfo();
				}
			},
			handleView(url) {
				this.imgName = url;
				this.visible = true;
			},
			timePeriodDateChange(e) {
				this.logTime = e;
				this.timePeriodDate[0] = e;
				this.timePeriodDate[1] = e;
				this.cidType = ["5"];
				console.log(this.timePeriodDate);
				this.getAdvData();
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;
				if (this.checkAll) {
					this.cidType = ["1", "2", "3", "4", "5", "6", "7"];
				} else {
					this.cidType = [];
				}
			},
			checkAllGroupChange(data) {
				if (data.length === 3) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
				this.getAdvData();
			},
			async AddRecordClick() {
				let that = this;
				this.logTime = '';

				let data = {
					token: that.token,
					uid: this.userInfo.id,
				};
				that.staticData = {};
				let res = await getOldSystemId(that, data);
				that.operationUser = res.data.item.old_uid;
				that.addRecordShow = true;
			},
			tabClick(e) {
				let that = this;
				if (e == "gjj") {
					that.cidType = 1;
				} else if (e == "fangdi") {
					that.cidType = 2;
				} else if (e == "chedi") {
					that.cidType = 3;
				} else if (e == "qiye") {
					that.cidType = 4;
				} else if (e == "zonghe") {
					that.cidType = 5;
				} else if (e == "pyq") {
					that.cidType = 6;
				} else if (e == "shebao") {
					that.cidType = 7;
				}
				this.getAdvData();
			},
			async getAdvData() {
				let that = this;
				var data = {};
				data.token = this.token;
				data.timePeriod = "7";
				data.operationUser = this.operationUser;
				data.timePeriodDate = that.timePeriodDate;
				data.cidType = this.cidType;
				let res = await getAdvTypeGroupByCityStaticList(that, data);
				that.datas = res.data.list;
				console.log(that.datas)
			},
			search() {
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.name = '';
				this.dateTime = '';
				this.getList();
			},
			async lookLog(log_id) {
				let that = this;
				let id = log_id;
				let data = {
					token: that.token,
					id: id,
				};
				let res = await getLogDetail(that, data);
				that.logTime = res.data.item.date_time;
				that.timePeriodDate[0] = res.data.item.date_time;
				that.timePeriodDate[1] = res.data.item.date_time;
				that.operationUser = res.data.item.operater;
				that.cidType = ["5"];
				if (res.code == 1) {
					var jsonStr = JSON.parse(res.data.item.ext_info); //将视频和图片的json转为数据
					that.$refs['upload'].uploadList = jsonStr.imgList;
					that.getAdvData();
					that.staticData = res.data.item;
					that.addRecordShow = true;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			save() {
				let that = this;
				that.throttle(async function() {
					let data = {
						token: that.token,
						type: that.tabs_value,
						form: that.form,
						staticData: that.staticData,
						timePeriodDate: that.timePeriodDate,
						imgList: that.$refs['upload'].uploadList,
						operationUser: that.operationUser
					}
					let res = await saveOperaterReport(that, data);
					if (res.code == 1) {
						this.form = {
							summarize: '',
							issue: '',
						};
						this.addRecordShow = false;
						this.$refs['recordList'].getList();
					}
				}, 500)
			},
			saveComment(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.throttle(async function() {
					let data = {
						token: that.token,
						id: id,
						remark: that.remarkValue
					}
					let res = await saveReportComment(that, data);
					if (res.code == 1) {
						that.$Message.success('评论成功')
						that.remarkValue = '';
						that.getList();
					}
				}, 500)
			}

		}
	}
</script>

<style scoped lang="less">
	.text-center {
		height: 580px;
		overflow: scroll;
	}

	.shijian {
		position: relative;
		left: 15px;
	}

	.xiaoxi {
		position: relative;
		left: -120px;
		top: 18px;
	}

	.icon-biao {
		display: flex;
		justify-content: left;
		font-size: 15px;
		margin-bottom: 30px;
	}

	.xiangqing {
		background-color: #F9FAFA;
	}

	.biaoti {
		font-weight: bold;
	}

	.biaogetoubu {
		background-color: #F9FAFA;
		border-bottom: 1px solid #E8EAEC;
	}

	.shuju {
		margin-bottom: 10px;
		text-align: left;
		text-align-last: justify;
		display: flex;
		justify-content: left;

		div {
			margin-right: 20px;
			width: 60px;
		}
	}

	.biaogelimian {
		display: flex;
		justify-content: space-around;
	}

	.shanchu {
		margin-right: 10px;
		color: #54A1F3;
		font-size: 15px;
	}

	.biaotou {
		display: flex;
		justify-content: space-between;
	}

	.xinjianbottom {
		margin-top: 60px;
		display: flex;
		justify-content: left;
	}



	.dialoglist {
		display: flex;
		justify-content: left;
		align-items: center;
		margin-bottom: 20px;
	}

	.assign {
		position: relative;
		left: 80%;
		top: -232px;
	}

	.top-add {
		position: relative;
		width: 30px;
		left: 80%;
		bottom: 30px;
	}

	.input-text {
		margin-top: 30px;
		display: flex;
		justify-content: left;
		align-items: center;

		div {
			margin: 0 10px;
		}
	}

	.top-save {
		position: relative;
		left: 70%;
		top: -30px;
	}

	.cascader {
		width: 380px;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;

		.child-div {
			width: 60px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.chongzhi {
		position: absolute;
		top: 16px;
		left: 280px;
	}

	.sousuo {
		height: 32px;
		width: 100%;
		margin-bottom: 20px;
	}

	.ivu-table-fixed-header thead tr th {
		text-align: center;
	}

	.list_width {
		div {
			width: 160px;
		}
	}

	.demo-upload-list {
		display: inline-block;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
